import React, { useEffect, useState } from 'react'
import DialogWrapper from '../../../../components/core-ui/DialogWrapper'
import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material'
import { fieldTemplateService } from '../../../../services/fieldTemplateService'
import { useAuthContext } from '../../../../hooks/useAuthContext'
import { serverActionService } from '../../../../services/serverActionService'
import { DeleteRounded } from '@mui/icons-material'
import { getTimeInMillis } from '../../../../utility/datetime'
import AddTranslationUI from './AddTranslationUI'
import { toast } from 'react-toastify'

const SetupKeyValuePair = ({ keyValuePairsForAction, showKeyValuePairsForAction }) => {
  const { user } = useAuthContext()
  const [fields, setFields] = useState([])
  const [translations, setTranslations] = useState([])
  const [newTranslations, setNewTranslations] = useState([])

  useEffect(() => {
    ;(async () => {
      // fetch activity field
      if (!keyValuePairsForAction?.trigger_activity_template_id) return
      const _fields = (
        await fieldTemplateService.getAllFieldsInActivity(
          user,
          keyValuePairsForAction?.trigger_activity_template_id
        )
      ).data
      setFields(_fields)

      // fetch all key value pairs from db
      await fetchAllTranslation()
    })()
  }, [keyValuePairsForAction])

  const fetchAllTranslation = async () => {
    const translations = await serverActionService.getActionTranslations(
      user,
      keyValuePairsForAction?.id
    )
    setTranslations(translations)
  }

  const deleteActionTranslation = async (id) => {
    try {
      await serverActionService.deleteActionTranslation(user, id)
      setTranslations(translations.filter((it) => it.id != id))
      toast.success('Added successfully!')
    } catch (error) {
      toast.error('Something went wrong!')
    }
  }

  const addNewActionTranslation = async () => {
    setNewTranslations([
      ...newTranslations,
      {
        id: getTimeInMillis(),
        field_template_id: null,
        value: null,
        list_data_type: null,
        list_data_metadata_key: null,
        outbound_server_action_id: keyValuePairsForAction?.id,
        is_matching_key: false,
        operation: null,
      },
    ])
  }

  const saveNewActionTranslation = async () => {
    try {
      const invalidKeys = newTranslations
        .filter((it) => it.key.startsWith('x_'))
        .map((it) => it.key)

      if (invalidKeys.length > 0) {
        return toast.error(`Keys can not start with x_. Affected keys: ${invalidKeys.join(', ')}`)
      }

      await serverActionService.saveActionTranslations(user, newTranslations)
      setNewTranslations([])
      await fetchAllTranslation()
      toast.success('Added successfully!')
    } catch (error) {
      toast.error('Something went wrong!')
    }
  }

  return (
    <DialogWrapper
      actions={null}
      open={keyValuePairsForAction != null}
      onClose={() => showKeyValuePairsForAction(null)}
      fullWidth
    >
      <Typography variant="h6" style={{ marginTop: 16 }}>
        {keyValuePairsForAction?.label}
      </Typography>
      <Typography variant="p">Key Value Pairs</Typography>
      <TableContainer style={{ marginTop: 16 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Field</TableCell>
              <TableCell>Key</TableCell>
              <TableCell>Value</TableCell>
              <TableCell>List Data Type</TableCell>
              <TableCell>Metadata Key</TableCell>
              <TableCell>Is matching key?</TableCell>
              <TableCell>Operation</TableCell>
              <TableCell>Table Operation</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {translations.map((translation) => {
              return (
                <TableRow>
                  <TableCell style={{ padding: 4 }}>
                    {
                      fields?.find((it) => it.id === translation.field_template_id)
                        ?.field_template_name
                    }
                  </TableCell>
                  <TableCell style={{ padding: 4 }}>{translation.key}</TableCell>
                  <TableCell style={{ padding: 4 }}>{translation.value}</TableCell>
                  <TableCell style={{ padding: 4 }}>{translation.list_data_type}</TableCell>
                  <TableCell style={{ padding: 4 }}>{translation.list_data_metadata_key}</TableCell>
                  <TableCell style={{ padding: 4 }}>
                    {translation.is_matching_key ? 'Yes' : 'No'}
                  </TableCell>
                  <TableCell style={{ padding: 4 }}>{translation.operation}</TableCell>
                  <TableCell style={{ padding: 4 }}>{translation.table_operation}</TableCell>
                  <TableCell>
                    <Tooltip title="Delete Action">
                      <IconButton onClick={() => deleteActionTranslation(translation?.id)}>
                        <DeleteRounded style={{ fontSize: 20 }} />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <Box>
        {newTranslations.map((translation) => {
          return (
            <AddTranslationUI
              translation={translation}
              fields={fields.filter(
                (field) => !translations.find((it) => it.field_template_id === field.id)
              )}
              setTranslation={(translation) => {
                setNewTranslations(
                  newTranslations.map((it) => (it.id === translation.id ? translation : it))
                )
              }}
            />
          )
        })}
      </Box>

      <Box style={{ display: 'flex', justifyContent: 'flex-end', padding: '16px 0px', gap: 16 }}>
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            setNewTranslations([])
            showKeyValuePairsForAction(null)
          }}
        >
          Hide
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={() => addNewActionTranslation(newTranslations)}
        >
          Add More
        </Button>
        {newTranslations?.length > 0 && (
          <Button color="primary" variant="contained" onClick={saveNewActionTranslation}>
            Save
          </Button>
        )}
      </Box>
    </DialogWrapper>
  )
}

export default SetupKeyValuePair
